import { endPoints, API_ROOT } from "../../../appSettings";
import { adalApiFetch } from "../../../authProvider";

export const GET_ENTITLEMENTS = "GET_ENTITLEMENTS";
export const GET_ENTITLEMENT = "GET_ENTITLEMENT";
export const UPDATE_ENTITLEMENT = "UPDATE_ENTITLEMENT";

export function getEntitlements(
  page = 1,
  limit = 10,
  sortBy = 2,
  orderBy = 1,
  family = -1,
  packageName = "",
  searchBy = 0,
  searchText = "",
  operation = 0,
  startDate = "",
  endDate = ""
) {
  const filterDate =
    startDate && endDate ? `&startDate=${startDate}&endDate=${endDate}` : "";
  const url = `${API_ROOT}${endPoints.entitlement}/list?page=${page}&limit=${limit}&sortBy=${sortBy}&orderBy=${orderBy}&unitFamilyId=${family}&packageName=${packageName}&searchText=${searchText}&searchBy=${searchBy}&operation=${operation}${filterDate}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch)
      .then((response) =>
        response.json().then((json) => {
          if (!response.ok) {
            return Promise.reject(json);
          }

          dispatch({ type: GET_ENTITLEMENTS, payload: json });
        })
      )
      .catch((error) => {
        throw Error(error);
      });
  };
}

export function getEntitlement(id) {
  const url = `${API_ROOT}${endPoints.entitlement}/${id}`;
  const options = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  };

  return (dispatch) => {
    return adalApiFetch(fetch, url, options, dispatch)
      .then((response) =>
        response.json().then((json) => {
          if (!response.ok) {
            return Promise.reject(json);
          }

          return dispatch({
            type: GET_ENTITLEMENT,
            isSuccess: true,
            payload: json,
          });
        })
      )
      .catch((error) => {
        return dispatch({
          type: GET_ENTITLEMENT,
          isSuccess: false,
          payload: error,
        });
      });
  };
}

export function updateEntitlement(id, isValid) {
  const url = `${API_ROOT}${endPoints.entitlement}/${id}/${isValid}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_ENTITLEMENT,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_ENTITLEMENT,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
}

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.voucherOverview}${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};
